// polyfills
require('core-js/stable');
require('regenerator-runtime/runtime');
window.fetch = require('whatwg-fetch').fetch;

if (module.hot) {
    module.hot.accept();
}

const ui = require('./ui/index.js');
const terms = require('./terms/index.js');
const vehicle = require('./vehicle/index.js');
const insured = require('./insured/index.js');
const offer = require('./offer/index.js');
const details = require('./details/index.js');
const summary = require('./summary/index.js');

window.State = require('./helpers.js').State;

const moment = require('moment');

if (process.env.NODE_ENV === 'development') {
    window.ui = ui;
    window.terms = terms;
    window.vehicle = vehicle;
    window.insured = insured;
    window.offer = offer;
    window.details = details;
    window.summary = summary;
}

terms.init();

//used for testing
// ui.state.flowId = '5fcc0a425043bfc7c0b24f73';

// vehicle.init();
// ui.state.slide = [1,0];
// vehicle.state.vin = 'VF1R9800X61772762';
// vehicle.state.class = '2001';
// vehicle.state.brand = '1028';
// vehicle.state.model = 'ACCORD';
// vehicle.state.maxWeight = 2030;
// vehicle.state.year = 2009;
// vehicle.state.seatNo = 5;
// vehicle.state.enginePower = 148;
// vehicle.state.engineDisplacement = 2354;
// vehicle.state.energySource = 'Gasoline';
// vehicle.state.plateNo = 'BZ08NAY';

// // insured.init();
// // ui.state.slide = [1, 2];
// insured.state.cnp = '1860327100139';
// insured.state.county = '4';
// insured.state.city = '1638';
// insured.state.date = moment('2020-12-07');
// insured.state.name = 'Roxana Vlajoaga';

// ui.state.slide = [2, 0];
// offer.init();

// ui.state.slide = [3, 0];
// details.init();
// details.state.email = 'adrian.lupu@fullscreendigital.ro';
// details.state.phone = '0769605848';
// details.state.street = 'Bulevardul Mircea Voda';
// details.state.streetNo = '3';

// ui.state.slide = [3,1];